module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/download-tip-a3355a866274172205a0e983a55e5b57.png";